import React from 'react';

function Checkmark(props) {
    const fill = props.fill || 'currentColor';
    const strokewidth = props.strokewidth || 1;
    const width = props.width || '1em';
    const height = props.height || '1em';

    return (
        <svg height={height} width={width} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth={strokewidth}>
                <polyline points="20 6 9 17 4 12" />
            </g>
        </svg>
    );
};

export default Checkmark; 